import React from "react"
import {
  adressItemTitle,
  adressItemTitleNotClickable,
  adressMore,
  adressItemTaxo,
  adressItemTaxoContainer,
  adressDetails,
  adressTop,
  adressInfos,
  adressInfosHidden,
} from "../styles/listAdresses.module.scss"
import { AdressItemTaxo } from "./styled-components/adresse-item-styled"
import PropTypes from "prop-types"
import TransitionFade from "../../../components/transition-fade"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import Obfuscate from "react-obfuscate"

const AdresseItem = ({
  adress,
  changeAdress,
  choosenAdress,
  initialAdress,
}) => (
  <>
    <EditButton link={"/node/" + adress.drupal_internal__nid + "/edit"} />
    <div className={adressTop}>
      <button
        tabIndex="0"
        onClick={() => {
          if (adress.field_coordon) {
            changeAdress(adress, choosenAdress, adress.title, initialAdress)
          }
        }}
        onKeyDown={() => {
          if (adress.field_coordon) {
            changeAdress(adress, choosenAdress, adress.title, initialAdress)
          }
        }}
        onFocus={() => {
          document.addEventListener("keydown", (event) => {
            if (event.key === "Enter") {
              if (adress.field_coordon) {
                changeAdress(adress, choosenAdress, adress.title, initialAdress)
              }
            }
          })
        }}
        className={
          adress.field_coordon &&
          (adress.field_coordon?.lat !== choosenAdress?.field_coordon?.lat ||
            adress.field_coordon?.lon !== choosenAdress?.field_coordon?.lon)
            ? adressItemTitle
            : adressItemTitleNotClickable
        }
        aria-expanded={
          adress.field_coordon === null
            ? false
            : adress.field_coordon?.lat === choosenAdress?.field_coordon?.lat &&
              adress.field_coordon?.lon === choosenAdress?.field_coordon?.lon
        }
      >
        {adress.title}
      </button>
      <TransitionFade
        className={adressMore}
        link={adress.path.alias}
        arialabel={"Plus d'infos - [" + adress.title + "]"}
      >
        Plus d&apos;infos
      </TransitionFade>
    </div>
    <div className={adressDetails}>
      <div
        className={
          adress.field_coordon &&
          (adress.field_coordon?.lat !== choosenAdress?.field_coordon?.lat ||
            adress.field_coordon?.lon !== choosenAdress?.field_coordon?.lon)
            ? adressInfosHidden
            : adressInfos
        }
      >
        {adress.field_adresse && (
          <>
            {adress.field_adresse.address_line1 && (
              <p>{adress.field_adresse.address_line1}</p>
            )}
            {adress.field_adresse.address_line2 && (
              <p>{adress.field_adresse.address_line2}</p>
            )}
            <p>{adress.field_adresse.postal_code}</p>
            <p>{adress.field_adresse.locality}</p>
          </>
        )}

        <b>
          <Obfuscate email={adress.field_mail} />
        </b>
        <br />
        <b>
          <Obfuscate tel={adress.field_telephone} />
        </b>
      </div>
      <div className={adressItemTaxoContainer} role={"list"}>
        {adress.relationships.field_taxonomie_thematique
          ?.slice(0, 3)
          .map((element, index) => (
            <AdressItemTaxo
              key={index}
              className={adressItemTaxo}
              role={"listitem"}
            >
              {element.name}
            </AdressItemTaxo>
          ))}
      </div>
    </div>
  </>
)

AdresseItem.propTypes = {
  adress: PropTypes.object.isRequired,
  changeAdress: PropTypes.func,
  choosenAdress: PropTypes.object,
  initialAdress: PropTypes.object,
}

export default AdresseItem
